document.querySelectorAll('[data-countdown-bar]').forEach((bar) => {
  const endTime = new Date(bar.dataset.countdownEnd).getTime();
  if (isNaN(endTime)) return;

  const days = bar.querySelector('[data-countdown-days]');
  const hours = bar.querySelector('[data-countdown-hours]');
  const minutes = bar.querySelector('[data-countdown-minutes]');
  const seconds = bar.querySelector('[data-countdown-seconds]');

  const pad = (value) => String(value).padStart(2, '0');

  let timer;
  const tick = () => {
    const remaining = endTime - Date.now();
    if (remaining <= 0) {
      bar.hidden = true;
      clearInterval(timer);
      return;
    }
    const totalSeconds = Math.floor(remaining / 1000);
    days.textContent = pad(Math.floor(totalSeconds / 86400));
    hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
    minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
    seconds.textContent = pad(totalSeconds % 60);
    bar.hidden = false;
  };

  tick();
  timer = setInterval(tick, 1000);
});
